module.exports = __webpack_public_path__ + "img/help_delete_account02.53a743f4.png";